<template>
  <div class="index_ custom-tab">
    <div id="tab_"></div>
    <!-- 选项卡 -->
    <a-tabs :defaultActiveKey="0" @change="callback">
      <a-tab-pane v-for="(item, index) in product.tabDtos" :key="index" class="pane_" :tab="item.tabName" :forceRender="true">
        <div :style="`overflow: hidden;${expandContent ? 'height: auto;' : 'height: 600px;'}`">
          <div v-if="index != tabLen">
            <div class="content_" v-if="$route.query.planCode === 'GFTYX20Hone' && item.tabName === '产品介绍'">
              <p><img src="https://image.ssish.com/core/material/1675046319218.jpg" /></p>
            </div>
            <div class="content_" v-else-if="$route.query.planCode === 'GFTYX20Htwo' && item.tabName === '产品介绍'">
              <p><img src="https://image.ssish.com/core/material/1675046344610.jpg" /></p>
            </div>
            <div class="content_" v-else-if="$route.query.planCode === 'GFTYX20Hone' && item.tabName === '条款及职业表等'">
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1640676177758.pdf" target="_self" title="1640676177758.pdf">国富人寿团体意外伤害保险（互联网专属）条款 </a></p>
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1680160526471.xls" target="_self" title="1640676293091.xls">职业类别表</a></p>
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1677576888270.pdf" target="_self" title="投保人声明">投保人声明</a></p>
              <p style="line-height: 16px"><a href="/files/guofu/国富人寿1-6类团体意外险（互联网）速算报价器-A版.xls" target="_self" title="国富人寿1-6类团意险（互联网）速算报价器">国富人寿1-6类团意险（互联网）速算报价器-A版</a></p>
              <p style="line-height: 16px"><a href="/files/guofu/3.3国富人寿拒保职业清单JB202212.pdf" target="_self" title="国富人寿拒保职业清单">国富人寿拒保职业清单</a></p>
              <p style="line-height: 16px"><a href="/files/guofu/国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单2023版.pdf" target="_self" title="国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单">国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单</a></p>
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1672821844409.pdf" target="_self" title="特别约定和免责条款">特别约定和免责条款</a></p>
              <p style="line-height: 16px;">
                <a href="https://image.ssish.com/core/material/1661223088160.pdf" target="_self" title="关于对公保费收取、保险发票开具说明">关于对公保费收取、保险发票开具说明</a>
              </p>
              <p style="line-height: 16px"><br /></p>
              <p><br /></p>
            </div>
            <div class="content_" v-else-if="$route.query.planCode === 'GFTYX20Htwo' && item.tabName === '条款及职业表等'">
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1640676177758.pdf" target="_self" title="1640676177758.pdf">国富人寿团体意外伤害保险（互联网专属）条款 </a></p>
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1680160526471.xls" target="_self" title="1640676293091.xls">职业类别表</a></p>
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1677576888270.pdf" target="_self" title="投保人声明">投保人声明</a></p>
              <p style="line-height: 16px"><a href="/files/guofu/国富人寿1-6类团体意外险（互联网）速算报价器-F版.xls" target="_self" title="国富人寿1-6类团意险（互联网）速算报价器">国富人寿1-6类团意险（互联网）速算报价器-F版</a></p>
              <p style="line-height: 16px"><a href="/files/guofu/3.3国富人寿拒保职业清单JB202212.pdf" target="_self" title="国富人寿拒保职业清单">国富人寿拒保职业清单</a></p>
              <p style="line-height: 16px"><a href="/files/guofu/国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单2023版.pdf" target="_self" title="国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单">国富人寿意外伤害医疗保险责任和意外伤害住院津贴保险责任免除医院清单</a></p>
              <p style="line-height: 16px"><a href="https://image.ssish.com/core/material/1672821893276.pdf" target="_self" title="特别约定和免责条款">特别约定和免责条款</a></p>
              <p style="line-height: 16px;">
                <a href="https://image.ssish.com/core/material/1661223088160.pdf" target="_self" title="关于对公保费收取、保险发票开具说明">关于对公保费收取、保险发票开具说明</a>
              </p>
              <p style="line-height: 16px"><br /></p>
              <p><br /></p>
            </div>
            <div class="content_" v-html="item.tabContent" v-else></div>
          </div>
          <div class="content_ bgColor" v-if="index == tabLen">
            <div class="flex item">
              <p class="name">承保公司：</p>
              <p class="val">{{ piluInfo.underCompanyName }}</p>
            </div>
            <div class="flex item">
              <p class="name">保司名称：</p>
              <p class="val">{{ piluInfo.companyName }}</p>
            </div>
            <div class="flex item">
              <p class="name">合作期限：</p>
              <p class="val">
                {{ piluInfo.cooperationStartDate }} 至
                {{ piluInfo.cooperationEndDate }}
              </p>
            </div>
            <div class="flex item">
              <p class="name">合作范围：</p>
              <p class="val">{{ piluInfo.cooperationScope }}</p>
            </div>
            <div class="flex item detail">
              <p class="name">详细信息：</p>
              <p class="val">{{ piluInfo.insuranceNoticeInfo }}</p>
            </div>
          </div>
        </div>
        <div v-if="item.tabContent && (item.tabContent.length > 300 || item.tabContent.indexOf('img') > -1)" class="spread_">
          <button class="inner-btn" :class="expandContent ? 'hide-btn' : ''" @click="handleExpandDetail">
            {{ expandContent ? '收起全部' : '展开全部' }}
            <img src="@/assets/image/down.png" class="icon_" />
          </button>
        </div>
        <div class="bottom_"></div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      piluInfo: {},
      expandContent: false
    };
  },
  computed: {
    tabLen() {
      return this.product.tabDtos ? this.product.tabDtos.length - 1 : 0;
    }
  },
  mounted() {
    const { p } = this.$route.query;
    if (p) {
      this.$api.queryPiluInfo(p).then(res => {
        if (res.data.returnCode == 0) {
          this.piluInfo = res.data.data || {};
        }
      });
    }
  },
  methods: {
    callback(key) {
      
      const perc = key * 100 + 0.001 + '%';
      let si = setTimeout(() => {
        
        document.getElementsByClassName('ant-tabs-content')[0].style = `margin-left: -${perc};`;
        clearTimeout(si);
      }, 400);
    },
    handleExpandDetail() {
      this.expandContent = !this.expandContent;
      if (!this.expandContent) {
        location.hash = '';
        location.hash = 'tab_';
      }
    }
  }
};
</script>

<style lang="scss">
.custom-tab {
  .ant-tabs-nav {
    width: 100%;
    div {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .ant-tabs-tab {
        width: 25%;
        margin: 0;
        padding: 24px 16px;
        font-size: 17px;
        font-weight: 600;
      }
      .ant-tabs-tab-active {
        color: #fe8f2d !important;
      }
    }
  }
}

.pane_ {
  font-size: 12px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);

  img {
    height: auto;
  }
}
.bgColor {
  background-color: rgb(252, 246, 238);
  padding: 10px;
  p {
    line-height: 20px;
  }
  .bold_ {
    font-weight: bold;
  }
}
.content_ p img {
  height: auto;
  width: 100%;
}
.content_ {
  min-height: 85px;
}
.content_ img {
  height: auto;
}

.spread_ {
  font-size: 13px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: rgba(254, 143, 45, 1);
  margin: 30px 0;
  text-align: right;

  .inner-btn {
    cursor: pointer;
    width: 200px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #ffffff;
    background: #f79647;
    border: 1px solid #f79647;
    .icon_ {
      width: 12px;
      margin-left: 6px;
    }
  }
  .hide-btn {
    .icon_ {
      transform: rotate(180deg);
    }
  }
}
.flex {
  display: flex;
  align-items: center;
  &.item {
    .name {
      min-width: 65px;
    }
  }
  &.detail {
    align-items: initial;
  }
}
</style>
